import classNames from "classnames";
import { createUseStyles } from "react-jss";
import { Loading } from "react-simple-chatbot";

const useStyles = createUseStyles((theme) => ({
  loadingContainer: {
    display: "flex",
    alignItems: "center",
  },
  avatar: {
    height: "100%",
    minWidth: "100%",
    transformOrigin: "bottom right",
    backgroundPosition: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    borderRadius: "50% 50% 0 50%",
  },
  botImage: {
    backgroundImage: "url(" + theme.avatarImage + ")",
  },
  botImageContainer: {
    height: 32,
    minWidth: 32,
    marginInlineEnd: 8,
  },
  "@media screen and (min-width: 688px) ": {
    botImageContainer: {
      height: 40,
      minWidth: 40,
    },
  },
}));

const Typing = () => {
  const styles = useStyles();

  return (
    <div className={styles.loadingContainer}>
      <div className={styles.botImageContainer}>
        <div
          alt="avatar"
          className={classNames(styles.avatar, styles.botImage)}
        />
      </div>
      <Loading />
    </div>
  );
};
export { Typing };
